import React from 'react'
import PropTypes from 'prop-types'
import CountrySelection from 'base/react/components/country_selection'
import TrayTwo from './tray_two'

export default function CountrySelectTray({ closeCountrySelectTray }) {
  return (
    <TrayTwo className="country-select-tray" scrollable onRequestClose={closeCountrySelectTray}>
      <CountrySelection forMobile closeCountrySelectTray={closeCountrySelectTray} />
    </TrayTwo>
  )
}

CountrySelectTray.propTypes = {
  closeCountrySelectTray: PropTypes.func,
}
